const Images = {
    hebe: {
        background: require('./hebe/background.png'),
        logo: require('./hebe/logo.png'),
        favicon: require('./hebe/favicon.png'),
        logo_gray: require('./hebe/logo_gray.png'),
        logo_ticket: require('./hebe/logo_ticket.png'),
    },
    comtodotel: {
        logo: require('./hebe/logo.png'),
        favicon: require('./hebe/favicon.png'),
        logo_gray: require('./hebe/logo_gray.png'),
        logo_ticket: require('./hebe/logo_ticket.png'),
    },
    marbu: {
        logo: require('./marbu/logo.png'),
        favicon: require('./marbu/favicon.png'),
        logo_ticket: require('./marbu/logo_ticket.png'),
    },
    telemuti: {
        logo: require('./telemuti/logo.png'),
        favicon: require('./telemuti/favicon.png'),
        logo_ticket: require('./telemuti/logo_ticket.png'),
    },
    rekete: {
        logo: require('./rekete/logo.png'),
        favicon: require('./rekete/favicon.png'),
        logo_gray: require('./rekete/logo_gray.png'),
        logo_ticket: require('./rekete/logo_ticket.png'),
    },
    icon: {
        control_panel: require('./icons/panel_control.png'),
        admin: require('./icons/admin.png'),
        clientes: require('./icons/clientes.png'),
        reportes: require('./icons/reportes.png'),
        conciliaciones: require('./icons/conciliaciones.png'),
        gear: require('./icons/gear.png'),
        reports: require('./icons/reports.png'),
        security: require('./icons/security.png'),
        store: require('./icons/store.png'),
        account: require('./icons/account.png'),
        control_panel_white: require('./icons/chart-custom-white.png'),
        gear_white: require('./icons/gear-white.png'),
        reports_white: require('./icons/reports-white.png'),
        security_white: require('./icons/security-white.png'),
        store_white: require('./icons/store-white.png'),
        chevron_left: require('./icons/chevron-left.png'),
        edit: require('./icons/edit.png'),
        account_circle: require('./icons/account-circle.png'),
        search: require('./icons/search.png'),
        arrow_back: require('./icons/arrow-back.png'),
        arrow_next: require('./icons/arrow-next.png'),
        check_circle: require('./icons/check-circle.png'),
        uncheck_circle: require('./icons/uncheck-circle.png'),
        add_image: require('./icons/icon-add-image.png'),
        ladas: require('./icons/ladas.png'),
        ruteo: require('./icons/ruteo.png'),
        panel_ruteo: require('./icons/panel_ruteo.png'),
        sale: require('./icons/sale.png'),
        loading: require('./icons/loading.gif'),
        download: require('./icons/download.png'),
        chevron_right_circle: require('./icons/chevron-right-circle.png'),
        chevron_left_circle: require('./icons/chevron-left-circle.png'),
        actions: require('./icons/actions.png'),
        columnas: require('./icons/columnas.png'),
        check_square: require('./icons/check-square.png'),
        uncheck_square: require('./icons/uncheck-square.png'),
        calendar: require('./icons/calendar.png'),
        pos: require('./icons/pos.png'),
        pos_bg: require('./icons/pos-bg.png'),
        support: require('./icons/support.png'),
    }
}

export default Images;